var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-edit-fields',{attrs:{"record":_vm.record,"labels":{
      name:{
        label:'Métier',
        placeholder:'Architecte, designer, etc...'
      }
    }}}),_c('blocks-field',{attrs:{"label":"Blocks de contenu","field":_vm.recordObject.blocks}}),_c('code-preview',{staticClass:"my-5",attrs:{"title":"Données","code":this.record}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }